import { useCallback } from 'react';
import { StackActions, useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';

import { useOrganisationInfo } from '@pletly/feature-organisation';
import { useLoggedUser } from '%context/LoggedUser';
import { RootStackParamList } from './types';

export const useGoHome = () => {
	const { role: userRole } = useLoggedUser();
	const { organisationInfo } = useOrganisationInfo();
	const { navigate, dispatch } = useNavigation<NativeStackNavigationProp<RootStackParamList>>();

	const goHome = useCallback(() => {
		if (organisationInfo?.uuid && userRole === 'ORGANISATION_ADMIN') {
			return navigate('Organisations', {
				uuid: organisationInfo.uuid,
			});
		}

		return dispatch(StackActions.replace('Home'));
	}, [userRole, organisationInfo, navigate, dispatch]);

	return goHome;
};
